/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./circle-close-button.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./circle-close-button.component";
var styles_CircleCloseButtonComponent = [i0.styles];
var RenderType_CircleCloseButtonComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_CircleCloseButtonComponent, data: {} });
export { RenderType_CircleCloseButtonComponent as RenderType_CircleCloseButtonComponent };
export function View_CircleCloseButtonComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["class", "close"]], null, [[null, "click"]], function (_v, en, $event) { var ad = true; var _co = _v.component; if (("click" === en)) {
        var pd_0 = (_co.onClose($event) !== false);
        ad = (pd_0 && ad);
    } return ad; }, null, null)), (_l()(), i1.ɵeld(1, 0, null, null, 0, "i", [["class", "fa fa-times"]], null, null, null, null, null))], null, null); }
export function View_CircleCloseButtonComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "lp2-circle-close-button", [], null, null, null, View_CircleCloseButtonComponent_0, RenderType_CircleCloseButtonComponent)), i1.ɵdid(1, 49152, null, 0, i2.CircleCloseButtonComponent, [], null, null)], null, null); }
var CircleCloseButtonComponentNgFactory = i1.ɵccf("lp2-circle-close-button", i2.CircleCloseButtonComponent, View_CircleCloseButtonComponent_Host_0, {}, { close: "close" }, []);
export { CircleCloseButtonComponentNgFactory as CircleCloseButtonComponentNgFactory };
//# sourceMappingURL=circle-close-button.component.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/shared/circle-close-button/circle-close-button.component.ngfactory.js
// module id = 1564
// module chunks = 27 28 29